<template>
  <div>
    <el-table
    :data="tableData"
    stripe
    :height="tabH">
      <el-table-column
        v-for="col in cols"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        key="edit"
        label="修改"
        width="80">
        <template v-if="col.prop == 'edit'" scope="scope">
          <el-button size="small" @click="edit(scope.row.guid)"><i class="el-icon-edit"></i></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import hintDlg from '@/components/hintDlg'

  export default {
    data () {
      return {
        cols: [
          {
            prop: 'guid',
            label: 'guid',
            width: 150
          },
          {
            prop: 'pGuid',
            label: '题目id',
            width: 80
          },
          {
            prop: 'hLevel',
            label: '提示级别',
            width: 80
          },
          {
            prop: 'content',
            label: '提示内容',
            width: 80
          },
          {
            prop: 'date',
            label: '日期',
            width: 100
          }
        ]
      }
    },
    props: ['tableData'],
    computed: {
      tabH () {
        return this.winH - (this.search ? this.search.getHeight() : 80) - 88
      }
    },
    methods: {
      edit (guid) {
        console.log('hintDlg->edit guid = ', guid)
        hintDlg({
          isEditData: true,
          guid: guid
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// hintTable.vue?75800258